module.exports = "<p>\n  lab-order works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/lab-order.component.html
// module id = ./src/app/views/patients/lab-order.component.html
// module chunks = main